import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { provideDashboardGlobals } from './dashboard.globals';
import { SOFTLINE_PERMISSION_DASHBOARD } from './dashboard.shared';
import { DashboardGuard } from './guards/dashboard.guard';

// legacy composition — the federation shell composes the same pieces via
// ./ModuleMetadata (launcher + translations) and ./ModuleGlobals (menu item)
export const dashboardProviders: Array<Provider | EnvironmentProviders> = [
  DashboardGuard,
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'dashboard',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'dashboard',
      language: 'en',
      translations: en,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#DASHBOARD.APP',
      icon: 'fa-regular fa-tachograph-digital',
      route: '/dashboard',
      permission: SOFTLINE_PERMISSION_DASHBOARD,
    });
  }),
  ...provideDashboardGlobals(),
];
